import { render, staticRenderFns } from "./MesaCardLibre.vue?vue&type=template&id=049e19c6"
import script from "./MesaCardLibre.vue?vue&type=script&lang=js"
export * from "./MesaCardLibre.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports